import React from 'react';
import PropTypes from 'prop-types';
import StorageManager from '../../StorageManager';
import InterfaceStorage from './InterfaceStorage';

export default class Interface extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            value: null,
        };
    }

    static get propTypes() {

        return {
            className: PropTypes.string,
            id: PropTypes.string.isRequired,
            storage: PropTypes.oneOf(InterfaceStorage.getAll()).isRequired,
            isRequired: PropTypes.bool,
        };
    }

    static async init(link) {

        return StorageManager.getFrom(link);
    }

    static get(storage, id, fromJson = false, throwError = true) {

        return StorageManager.get(storage, id, fromJson, throwError);
    }

    componentDidMount() {

        if (!this.state.value) {

            const value = Interface.get(this.props.storage, this.props.id, false, !this.props.isRequired);
            this.setState({ value });
        }
    }

    render() {

        return <div
            className={ this.props.className ?? null }
            dangerouslySetInnerHTML={{ __html: this.state.value }} />;
    }

}